import { alertStatsSchema } from "@redotech/redo-dispute-db-schema/dispute-alert-analytics";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getAlertStats = {
  name: "getAlertStats" as const,
  input: z.object({
    startDate: zExt.plainDate().optional(),
    endDate: zExt.plainDate().optional(),
  }),
  output: alertStatsSchema,
};
